import * as React from "react";

// NPM
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import clsx from "clsx";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { TextFieldProps, Typography } from "@material-ui/core";

// Utility
import Utility from "../../domain/classes/Utility";

// Interfaces
import ICountryData from "../../domain/interfaces/ICountryData";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
		phoneInputContainer: {
			width: "100%",
			height: 40,
			paddingLeft: "56px !important",
			outline: "none !important",
		},
		flagButton: {
			"& div.selected-flag": {
				paddingLeft: "16px !important",
			},
		},
		default: { border: "1px solid #bfbfbf !important" },
		error: {
			border: `1px solid ${theme.palette.error.main} !important`,
		},
		helperText: {
			color: theme.palette.error.main,
		},
	});

export interface FormattedPhoneInputProps
	extends React.HTMLAttributes<HTMLDivElement> {
	value: string;
	onPhoneChange: (
		event: React.FocusEvent<HTMLInputElement>,
		data: {} | ICountryData
	) => void;
	isInternationalFormat: boolean;
	disableDropdown: boolean;
}

const FormattedPhoneInput = React.forwardRef<
	HTMLDivElement,
	FormattedPhoneInputProps & WithStyles<typeof styles> & TextFieldProps
>(
	(
		{
			value,
			classes,
			className,
			onPhoneChange,
			isInternationalFormat,
			disableDropdown,
			helperText,
			error,
			onFocus,
		},
		ref
	) => {
		return (
			<div ref={ref} className={clsx(classes.root, className)}>
				<PhoneInput
					value={value}
					onBlur={onPhoneChange}
					preferredCountries={["au"]}
					country={"au"}
					enableSearch={isInternationalFormat}
					inputStyle={{ width: "100%" }}
					autoFormat={isInternationalFormat}
					disableCountryCode={!isInternationalFormat}
					disableDropdown={disableDropdown}
					disableSearchIcon={!isInternationalFormat}
					placeholder="Enter your number here"
					specialLabel=""
					inputClass={clsx(
						classes.phoneInputContainer,
						error ? classes.error : classes.default
					)}
					buttonClass={classes.flagButton}
					onFocus={onFocus}
					masks={{ au: "... ... ..." }}
				/>
				{helperText && (
					<Typography
						variant="caption"
						className={classes.helperText}
					>
						{helperText}
					</Typography>
				)}
			</div>
		);
	}
);

const StyledFormattedPhoneInput = withStyles(styles, {
	name: Utility.generateClassName("FormattedPhoneInput"),
})(FormattedPhoneInput);

export default StyledFormattedPhoneInput;
